import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-573782d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","overflow":"auto","height":"100%"} }
const _hoisted_2 = { class: "submit-warp" }
const _hoisted_3 = {
  key: 0,
  class: "container"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex van-row--align-center map-ctrl"
}
const _hoisted_5 = {
  type: "text",
  style: {"padding":"5px","margin-right":"10px","background-color":"#FFF"}
}

import { ref, onMounted } from "vue";
import AppFieldEditor from "@/components/AppFieldEditor.vue";
import { post } from '@/api/neighborActivityApi';
import { Toast as toast, Dialog as dialog } from 'vant';
import { useRouter } from "vue-router";
import { areaList as areaListData } from "@vant/area-data";
import { Area as vanArea } from "vant";
import { getTenantUser } from '@/api/userTenantApi';
import Map from "@/components/MapContainer.vue";
import { getLocation } from "@/modular/Weixinh5";
import { Ref } from "vue";

const day = (1000 * 60 * 60 * 24);

export default /*#__PURE__*/_defineComponent({
  __name: 'NeighborActivity',
  setup(__props) {

const router = useRouter();
const areaList = ref(areaListData);
const showMap = ref(false);
/**
 * 显示地图上的input
 * 因为这个input是html
 * 所以要等到地图加载出来再显示，不然很丑
 */
const showMapCtrl = ref(false);

const formData = ref({
    title: "",
    actHostUser: "",
    phone: "",
    startActTime: NaN,
    endActTime: NaN,  // 需求上没有这个字段
    province: "",
    city: "",
    district: "",
    address: "",
    content: "",
    // watchCount: 0,
    // rejectReason: "string",
    // helpStatus: 1,
});
const area = ref({
    val: null,
    showPopover: false,
});

onMounted(() => {
    initTestData();
    getUserInfo();
});

// onActivated(() =>{
//     getUserInfo();
// })

// 测试数据，isTest=true,方便调试新增
function initTestData() {
    const isTest = false;
    if (isTest) {
        formData.value.content = `芳姨是长洲街的一名智力残障长者，与智力障碍的儿子一起相依为命多年。母子都患有一定程度的高血压和糖尿病，因为身体比较肥胖，芳姨的腰腿承受较大的身体负担，长此以往，导致腿脚不方便，每日外出都靠着别人送的一个破旧的手推车，慢慢推着小车行走。<br/>
在最近一次探访芳姨时，芳姨提出目前使用的手推车已经很旧了，而且螺丝脱落，变得十分不稳，向社工求助，表示希望买部新的手推车。<br/>
考虑到芳姨外出的安全，社工在收到芳姨的求助后，即刻开始行动...着手开始帮助芳姨在洋城益购上发布微心愿,.经过一段时间的转发和征集，芳姨的微心愿被点亮,社工立即着手购买物资为芳姨圆梦。`;
        formData.value.title = "圆梦微心愿，助残暖人心 【洋城益购】";
        formData.value.actHostUser = "小雨儿;";
        formData.value.phone = "15888888888;";
        formData.value.startActTime = maxDate.value.getTime();
        formData.value.endActTime = maxDate.value.getTime();  // 需求上没有这个字段
        formData.value.province = "广东省";
        formData.value.city = "广州市";
        formData.value.district = "天河区";
        formData.value.address = "中山大道100号";
        area.value.val = `${formData.value.province}-${formData.value.city}-${formData.value.district}`;
    }
}


function onShowDateTimePicker(pickerType) {
    showDateTimePicker.value = true;
    dateTimePickerType.value = pickerType;
}

function areaPickerConfirm(result: any) {
    const areaData = result.map((a: any) => a.name);
    console.log(areaData)
    area.value.val = areaData.join("-");
    formData.value.province = areaData[0];
    formData.value.city = areaData[1];
    formData.value.district = areaData[2];
    area.value.showPopover = false;
}


const now = parseInt((new Date().getTime() / day).toString()) * day;
const minDate = ref(new Date(now + day));
const maxDate = ref(new Date(now + day * 30));

function dataTimeConfirm(val: Date) {
    if (dateTimePickerType.value == 'start') {
        formData.value.startActTime = val.getTime();
    } else if (dateTimePickerType.value == 'end') {
        formData.value.endActTime = val.getTime();
    }
    console.error(formData);

    showDateTimePicker.value = false;
}
function dateTimePickerfilter(type, options) {
    if (type === 'minute') {
        return options.filter((option) => Number(option) % 5 === 0);
    }
    return options;
}

const showDateTimePicker = ref(false);
const dateTimePickerType = ref('');
async function onSubmit() {
    const id = await post(formData.value);
    if (!id) {
        toast.fail("保存失败");
        return;
    }
    dialog({ message: "保存成功，请等待后台人员审批，通过后才能查看到" })
    router.push('/mulin');
}

const rules = ref({
    title: [{ required: true, message: '请填写帖子主题' }],
    actHostUser: [{
        required: true,
        message: '请输入活动主持人姓名，多名请用“，”隔开',
    }],
    phone: [{ required: true, message: '请填写联系电话' }],
    startActTime: [{ required: true, message: '请填写需要时间' }],
    endActTime: [{ required: true, message: '请填写需要时间' }],
    area: [{ required: true, message: '选择省市区' }],
    address: [{ required: true, message: '请输入活动详细地址' }],
});

const userInfo:Ref = ref({});
const getUserInfo = async ()=> {
    userInfo.value = await getTenantUser();
}

const showAuthTip= () => {
    toast('您还未实名认证，请认证后操作');
}
const mapAddress = ref('');

const handleOpenMap = () => {
    showMap.value = true;
};

const mapConfig = {
    viewMode: "3D", //是否为3D地图模式
    zoom: 14, //初始化地图级别
    center: [0, 0], //初始化地图中心点位置
};

const latestActivityInfo = {
    longitude: 0,
    latitude: 0,
};

let latitude = 23.132755
let longitude = 113.32842


const initMap = async ({ map, AMap }) => {
    console.log(map, AMap)
    let result: any;
    try {
        result = await getLocation();
    } catch (error) {
        console.error(error);
        console.error(8787878);

        // 如果获取不到定位，就定位到北京天安门
        result = {
            latitude: 39.909187,
            longitude: 116.397451,
            speed: 2,
            accuracy: 1,
        };
    } finally {
        console.log(
            "this.latestActivityInfo :>> ",
            latestActivityInfo
        );

        latitude = Number(result.latitude);
        longitude = Number(result.longitude);

        mapConfig.center = [longitude, latitude];

        // addCircle(map, AMap, mapConfig.center);

        setZoomAndCenter(
            map,
            mapConfig.zoom,
            mapConfig.center
        );

        addCenterMarker(
            map,
            AMap,
            mapConfig.center[0],
            mapConfig.center[1]
        );

        console.log(geocoder)

        await addplugin(AMap);

        geocoder.getAddress(mapConfig.center, function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
                // result为对应的地理位置详细信息
                mapAddress.value = result.regeocode.formattedAddress
            }
        })

        // addDestinationMarker(map, AMap, latestActivityInfo.longitude, latestActivityInfo.latitude);
        addClick(map, AMap);
    }
}

const handleMapComplete = () => {
    showMapCtrl.value = true;

    // initMap({map, AMap});
}

const addCenterMarker = (map: any, AMap: any, longitude, latitude) => {
    const marker = new AMap.Marker({
        icon: new AMap.Icon({
            image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
            size: new AMap.Size(30, 38.48), //设置icon的大小
            imageSize: new AMap.Size(30, 38.48),
        }),
        // icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
        position: [longitude, latitude],
        anchor: "bottom-center",
    });
    marker.setMap(map);
}

// 这个地图不会进行双向绑定，所以数据要自己set
const setZoomAndCenter = async (map: any, zoom: number, center: Array<number>) => {
    map.setZoomAndCenter(zoom, center);
}

// const addCircle = (map: any, AMap: any, center: Array<any>) => {
//     const circle = new AMap.Circle({
//         map: map,
//         center: center, //设置线覆盖物路径
//         radius: 1000,
//         strokeColor: "#3366FF", //边框线颜色
//         strokeOpacity: 0.3, //边框线透明度
//         strokeWeight: 3, //边框线宽
//         fillColor: "#1791fc", //填充色
//         fillOpacity: 0.2, //填充透明度
//     });

//     circle.setMap(map);
// };
// const addDestinationMarker = (map: any, AMap: any, longitude, latitude) => {
//     const marker = new AMap.Marker({
//         // icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png",
//         icon: new AMap.Icon({
//             image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
//             size: new AMap.Size(30, 38.48), //设置icon的大小
//             imageSize: new AMap.Size(30, 38.48),
//         }),
//         position: [longitude, latitude],
//         anchor: "bottom-center",
//     });
//     marker.setMap(map);
// }

let geocoder = null;
const addClick = (map: any, AMap: any) => {
    map.on('click', function (e) {
        map.clearMap();
        addCenterMarker(map, AMap, e.lnglat.lng, e.lnglat.lat,)
        geocoder.getAddress(e.lnglat, function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
                // result为对应的地理位置详细信息
                mapAddress.value = result.regeocode.formattedAddress
            }
        })
    });
}
const addplugin = async (AMap: any) => {

    return new Promise((reslove) => {
        //此插件用来显示当前位置，可在引入API时一同引入
        AMap.plugin('AMap.Geocoder', function () {
            geocoder = new AMap.Geocoder({
                // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                city: '010'
            })

            reslove(true);
        })
    });
}

const setAddress = () => {
    formData.value.address = mapAddress.value;
    showMap.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      onSubmit: onSubmit,
      "input-align": "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: formData.value.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
          name: "帖子主题",
          label: "帖子主题",
          placeholder: "请输入帖子标题主题，建议5~30个字",
          maxlength: "30",
          rules: rules.value.title
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.actHostUser,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.actHostUser) = $event)),
          label: "活动主持人",
          placeholder: "请输入活动主持人姓名，多名请用“，”隔开",
          maxlength: "50",
          rules: rules.value.actHostUser
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.phone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.phone) = $event)),
          label: "联系电话",
          placeholder: "请填写联系电话",
          rules: rules.value.phone,
          maxlength: "20"
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          "model-value": formData.value.startActTime,
          readonly: "",
          label: "活动开始时间",
          placeholder: "请填写活动开始时间",
          "is-link": "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (onShowDateTimePicker('start'))),
          rules: rules.value.startActTime
        }, {
          input: _withCtx(() => [
            _createTextVNode(_toDisplayString(new Date(formData.value.startActTime)?.format('yyyy-MM-dd HH:mm')), 1)
          ]),
          _: 1
        }, 8, ["model-value", "rules"]),
        _createVNode(_component_van_field, {
          "model-value": formData.value.endActTime,
          readonly: "",
          label: "活动结束时间",
          placeholder: "请填写活动开始时间",
          "is-link": "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (onShowDateTimePicker('end'))),
          rules: rules.value.endActTime
        }, {
          input: _withCtx(() => [
            _createTextVNode(_toDisplayString(new Date(formData.value.endActTime)?.format('yyyy-MM-dd HH:mm')), 1)
          ]),
          _: 1
        }, 8, ["model-value", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: area.value.val,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((area.value.val) = $event)),
          label: "活动地区",
          readonly: "",
          "right-icon": " iconfont d-dizhi addr-ico",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (area.value.showPopover = true)),
          rules: rules.value.area
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.address,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.address) = $event)),
          "right-icon": " iconfont d-dizhi addr-ico",
          label: "活动详细地址",
          placeholder: "活动详细地址",
          rules: rules.value.address,
          maxlength: "30",
          onClickRightIcon: handleOpenMap
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(AppFieldEditor, {
          label: "帖子内容",
          modelValue: formData.value.content,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.content) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_2, [
          (userInfo.value.isIdCardVerfiy == true)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 0,
                block: "",
                class: "btn-submit d-theme-btn",
                type: "primary",
                "native-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 提交帖子 ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_van_button, {
                key: 1,
                block: "",
                class: "btn-submit d-theme-btn",
                type: "primary",
                onClick: showAuthTip
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 提交帖子 ")
                ]),
                _: 1
              }))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      teleport: "body",
      show: showDateTimePicker.value,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((showDateTimePicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          type: "datetime",
          title: "选择年月日和时间",
          "min-date": minDate.value,
          "max-date": maxDate.value,
          onConfirm: dataTimeConfirm,
          onCancel: _cache[9] || (_cache[9] = ($event: any) => (showDateTimePicker.value = false)),
          filter: dateTimePickerfilter
        }, null, 8, ["min-date", "max-date"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: area.value.showPopover,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((area.value.showPopover) = $event)),
      teleport: "body",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(vanArea), {
          onConfirm: areaPickerConfirm,
          "area-list": areaList.value,
          value: "440106"
        }, null, 8, ["area-list"])
      ]),
      _: 1
    }, 8, ["show"]),
    (showMap.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(Map, {
            onInitMap: initMap,
            onMapComplete: handleMapComplete,
            ref: "mapRef",
            mapConfig: mapConfig
          }, null, 512),
          (showMapCtrl.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(mapAddress.value), 1),
                _createVNode(_component_van_button, {
                  size: "small",
                  type: "primary",
                  onClick: setAddress,
                  style: {"flex-shrink":"0"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确认")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})